<template>
  <v-container>

    <v-col cols="12" class="mb-1 d-flex justify-space-between align-center">
      <h3 class="mb-0">Início do Trabalho Ordem De Produção</h3>
      <!-- Botão Salvar Abertura -->
      <v-btn v-if="podeSalvar" color="green" @click="abrirModalDeConfirmacao">
        Salvar Abertura
      </v-btn>

      <v-btn color="secondary" class="mx-2" @click="opcaoconfirmCancelar">
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
    </v-col>

    <!-- Diálogo de Carregamento -->
    <v-dialog v-model="loadingDialog" persistent max-width="300">
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="green"></v-progress-circular>
          <p>{{ mensagemDialog }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmação de cancelamento -->
    <v-dialog v-model="cancelarDialog" max-width="500">
      <v-card>
        <v-card-title class="text-danger"> Confirmar Cancelamento</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Tem certeza de que deseja cancelar? Todas as mudanças serão perdidas.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelarDialog = false">Não</v-btn>
          <v-btn color="red darken-1" text @click="voltarMenu">Sim, Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-row dense>
      <v-col dense v-if="!chefeSelecionado" cols="9">
        <v-text-field label="ID Chefe" v-model="id_chefe" @keyup.enter="buscarChefe" :disabled="loading"
          variant="outlined"></v-text-field>
      </v-col>
      <v-col dense v-if="!chefeSelecionado" cols="3">
        <v-btn color="green" @click="buscarChefe" :disabled="loading" class="ml-2">
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Exibir informações do Chefe após seleção -->
    <div v-if="chefeSelecionado">
      <!-- Informações do Chefe -->
      <v-card class="mb-4 chefe-card">
        <v-row>
          <v-col cols="12">
            <span><strong>Chefe:</strong> {{ chefeSelecionado.id }} -
              {{ chefeSelecionado.nome }}</span>
          </v-col>
          <v-col v-if='setorSelecionado' cols="12">
            <span><strong>Setor:</strong> {{ setorSelecionado.descricao_setor }}</span>
          </v-col>
        </v-row>
      </v-card>


      <!-- Campo de Filtro -->
      <v-card class="mb-4">
        <v-card-text>
          <v-text-field
            v-model="filtroOrdens"
            label="Filtrar por ID Pedido, ID Ordem, Cliente ou Modelo"
            prepend-inner-icon="mdi-magnify"
            clearable
            variant="outlined"
            hint="Digite para filtrar as ordens"
            persistent-hint
          ></v-text-field>
        </v-card-text>
      </v-card>

      <!-- Lista de Ordens -->
      <v-row>
        <v-col cols="12" v-for="ordem in ordensFiltradasComputada" :key="ordem.id">
          <v-card class="mb-4">
            <!-- Título do Card -->
            <v-card-title :class="{
              'ordem-selecionada': ordem.funcionariosSelecionados.length > 0,
              'ordem-nao-selecionada': ordem.funcionariosSelecionados.length === 0,
            }" @click="toggleOrdem(ordem.id)" class="d-flex align-center justify-space-between  ">
              <div>
                <strong>Ordem:</strong> {{ ordem.numero_ordem }}
                <strong>Pedido:</strong> {{ ordem.numero_pedido }}
                <br />

                <strong>Qtd:</strong>
                {{ ordem.quantidade }}
                <br />

                <strong>Previsão Entrega:</strong> {{ formatarData(ordem.previsao_entrega) }}
                <br />
                <strong>Etapa:</strong> {{ ordem.etapata }} : {{ ordem.etapataComplemento }}
                <strong>Modelo:</strong> {{ ordem.modelo }}
                <br />
                <strong>Cliente:</strong> {{ ordem.cliente }}
              </div>
              <div class="d-flex align-center">
                <span>{{ ordem.funcionariosSelecionados.length }} Func.</span>
                <v-icon>{{ ordem.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
            </v-card-title>

            <!-- Detalhes ao Expandir -->
            <v-expand-transition>
              <div v-if="ordem.expanded">
                <v-divider></v-divider>

                <!-- Botões para Marcar/Desmarcar Todos -->
                <v-card-text>
                  <v-row class="mb-4">
                    <v-col cols="12" class="d-flex justify-start">
                      <v-btn outlined color="green" @click="marcarTodosFuncionarios(ordem.id)">
                        Marcar Todos
                      </v-btn>
                      <v-btn outlined color="red" class="ml-2" @click="desmarcarTodosFuncionarios(ordem.id)">
                        Desmarcar Todos
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Tabela de Funcionários -->
                  <v-data-table :items="ordem.funcionariosDisponiveis" :headers="headers" item-value="id"
                    class="elevation-1" dense :items-per-page="-1" disable-pagination hide-default-footer>
                    <template #item.selecionado="{ item }">
                      <v-btn :color="ordem.funcionariosSelecionados.includes(item.id) ? 'green' : 'red'" text
                        @click="alternarSelecaoFuncionario(ordem.id, item.id)">
                        {{ ordem.funcionariosSelecionados.includes(item.id) ? '✔️' : '✖️' }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>





      <!-- Adicionar Funcionário e Máquinas -->
      <div v-if="setorSelecionado">
        <!-- Seleção de Funcionário -->
        <v-col cols="12">


          <v-row>

            <v-col cols="9">
              <v-text-field label="ID Funcionário" v-model="currentFuncionarioSelecionadoId"
                @keyup.enter="buscarFuncionario" :disabled="loading || !!currentFuncionario" ref="funcionarioInput"
                variant="outlined"></v-text-field>
            </v-col>
            <v-col cols="3">


              <v-btn color="green" @click="buscarFuncionario" :disabled="loading || !!currentFuncionario" class="ml-2">
                Buscar
              </v-btn>
              <!-- Botões de Ação -->
              <v-btn class="ml-3" color="blue" @click="confirmFinalizarFuncionarios">
                Ocultar Funcionários
              </v-btn>


            </v-col>
          </v-row>

          <!-- Exibir informações do funcionário selecionado -->

        </v-col>
      </div>

      <!-- Lista de Funcionários Adicionados -->
      <div v-if="funcionariosSelecionados.length > 0 && diaglogSelecaoFuncionario">
        <v-row>
          <v-col cols="12" v-for="(funcionarioObj, index) in funcionariosSelecionados.slice().reverse()"
            :key="funcionarioObj.funcionario.id">
            <v-card class="mb-2" outlined rounded elevation="2" style="padding: 10px">
              <!-- Título do Card com Foto e Nome -->
              <v-card-title style="padding: 0">
                <v-row align="center" no-gutters>
                  <!-- Foto do Funcionário -->
                  <v-col cols="2" class="text-center">
                    <v-img :src="getChefeFotoUrl(funcionarioObj.funcionario.foto_nome)" alt="Foto do Funcionário"
                      class="employee-photo"></v-img>
                  </v-col>
                  <!-- Nome, Cargo e Botão -->
                  <v-col cols="10">
                    <div class="ml-2 d-flex justify-space-between align-center">
                      <!-- Nome e Cargo -->
                      <div>
                        <div class="text-body-1 font-weight-bold text-primary">
                          {{ funcionarioObj.funcionario.id }}
                        </div>
                        <div class="text-body-2 text-muted">
                          {{ funcionarioObj.funcionario.nome }}
                        </div>
                        <div class="text-body-2 text-muted">
                          {{ funcionarioObj.funcionario.cargo_nome || "Cargo não informado" }}
                        </div>
                      </div>


                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- Botão Excluir -->
                  <v-btn flat class="mb-2" color="red" @click="removerFuncionario(funcionarioObj.funcionario.id)">
                    <v-icon left>mdi-delete</v-icon> Excluir
                  </v-btn>
                </v-row>
              </v-card-title>
            </v-card>
          </v-col>

        </v-row>
      </div>


      <!-- Diálogo de Confirmação do Expediente -->
      <v-dialog v-model="confirmFinalizarExpedienteDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Confirmação</v-card-title>
          <v-card-text>
            Tem certeza de que deseja finalizar a abertura do expediente?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="confirmFinalizarExpedienteDialog = false">
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" text @click="salvarAbertura">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de Sucesso -->
      <v-dialog v-model="successDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Sucesso</v-card-title>
          <v-card-text> Abertura Salva com sucesso! </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="voltarMenu">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de Erro -->
      <v-dialog v-model="errorDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Erro</v-card-title>
          <v-card-text>
            Ocorreu um erro ao enviar os dados. Tente novamente.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="errorDialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de Cancelamento -->
      <v-dialog v-model="cancelarDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Confirmar Cancelamento</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            Tem certeza de que deseja cancelar? Todas as mudanças serão
            perdidas.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="cancelarDialog = false">
              Não
            </v-btn>
            <v-btn color="red darken-1" text @click="cancelarAcao">
              Sim, Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


  </v-container>
</template>

<script>
import { maquinaMapaService } from "@/services/maquinaMapaService";
import { funcionarioService } from "@/services/funcionarioService";
import { aberturaExpedienteService } from "@/services/aberturaExpedienteService";
import { useUserStore } from "@/store/userStore";

import { toastInjectionKey, useToast } from "vue-toastification";

const toast = useToast();
// Removido: const userStore = useUserStore();
// O userStore será inicializado dentro do componente para evitar erros

export default {
  data() {
    return {
      // Inicialização do userStore dentro do componente
      userStore: useUserStore(),
      headers: [
        { title: "Selecionar", value: "selecionado", sortable: false, align: "center" },
        { title: "ID", value: "id", align: "start" },
        { title: "Nome", value: "nome", align: "start" },
      ],
      diaglogSelecaoFuncionario: true,
      dialogAdicionarFuncionario: false,
      mensagemDialog: "",
      id_chefe: "",
      id_chefe_setor: "",
      id_chefe_subsetor: "",
      chefeSelecionado: null,
      filtroOrdens: "",
      currentFuncionarioSelecionadoId: "",
      currentFuncionario: null,
      currentMaquinasSelecionadas: [],
      funcionariosSelecionados: [], // Array de funcionários e suas máquinas
      funcionarios: [], // Lista de todos os funcionários carregados
      maquinas: [],
      ordensDoSetor: [],
      setores: [],
      subSetores: [],
      setorSelecionado: null,
      searchSetor: "",
      sheetSetor: false,
      confirmFinalizarExpedienteDialog: false,
      adicionarMaisFuncionariosDialog: false,
      loadingDialog: false,
      successDialog: false,
      errorDialog: false,
      cancelarDialog: false,
      loading: true, // Indica se os dados dos funcionários estão sendo carregados
    };
  },
  computed: {
    nomeUsuario() {
      return this.userStore.objetoUsuario?.name || "Sem Usuário";
    },
    ObjUsuario() {
      return this.userStore.objetoUsuario || "Sem Usuário";
    },

    // Computed property para ordens filtradas
    ordensFiltradasComputada() {
      if (!this.filtroOrdens || this.filtroOrdens.trim() === "") {
        return this.ordensDoSetor;
      }

      const filtro = this.filtroOrdens.toLowerCase().trim();
      
      return this.ordensDoSetor.filter(ordem => {
        // Filtrar por ID do pedido
        const idPedido = ordem.numero_pedido?.toString().toLowerCase() || "";
        
        // Filtrar por ID da ordem
        const idOrdem = ordem.numero_ordem?.toString().toLowerCase() || "";
        
        // Filtrar por nome do cliente
        const nomeCliente = ordem.cliente?.toLowerCase() || "";
        
        // Filtrar por descrição do modelo
        const descricaoModelo = ordem.modelo?.toLowerCase() || "";
        
        return idPedido.includes(filtro) ||
               idOrdem.includes(filtro) ||
               nomeCliente.includes(filtro) ||
               descricaoModelo.includes(filtro);
      });
    },

    // Verifica se ordensDoSetor existe e se funcionariosSelecionados é um array válido
    podeSalvar() {
      // Verifica se há alguma ordem com funcionários selecionados
      if (Array.isArray(this.ordensDoSetor)) {
        const existeFuncionarioSelecionado = this.ordensDoSetor.some(
          ordem => Array.isArray(ordem.funcionariosSelecionados) && ordem.funcionariosSelecionados.length > 0
        );

        console.log("podeSalvar retornou:", existeFuncionarioSelecionado); // Log para depuração
        return existeFuncionarioSelecionado;
      }

      // Caso ordensDoSetor não seja um array válido
      console.log("podeSalvar retornou: false (ordensDoSetor inválido)");
      return false;

    },


  },
  methods: {
    // Transforma a data para o formato dd-mm-aaaa
    formatarData(data) {
      if (!data) return "";
      
      // Se a data contém 'T', é formato ISO, extrair apenas a parte da data
      let dataLimpa = data;
      if (data.includes('T')) {
        dataLimpa = data.split('T')[0];
      }
      
      const [ano, mes, dia] = dataLimpa.split("-").map(Number);
      
      // Verificar se os valores são válidos
      if (isNaN(ano) || isNaN(mes) || isNaN(dia)) {
        return "Data inválida";
      }
      
      return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${ano}`;
    },

    // Método para finalizar a abertura do expediente
    abrirModalDeConfirmacao() {
      this.confirmFinalizarExpedienteDialog = true;
    },

    async salvarAbertura() {
      this.loadingDialog = true; // Mostra o carregamento
      this.mensagemDialog = "Salvando abertura..."; // Mensagem de carregamento
      const toast = useToast(); // Para exibir mensagens de sucesso ou erro

      try {
        // Extrair valores reais de ordensDoSetor
        const ordensReais = this.ordensDoSetor.map(ordem => ordem._custom?.value || ordem);

        // Filtrar ordens com base nos funcionários selecionados
        const ordensComFuncionarios = ordensReais.filter(ordem =>
          Array.isArray(ordem.funcionariosSelecionados) && ordem.funcionariosSelecionados.length > 0
        );

        // Montar os dados para envio
        const dadosAbertura = {
          chefe_id: this.chefeSelecionado.id,
          setor_id: this.setorSelecionado.id,
          observacao: this.observacao || "",
          data_abertura: this.dataAbertura, // Exemplo: "2025-01-08 08:00:00"
          expediente_ordem: ordensComFuncionarios.map(ordem => ({
            id_ordem: ordem.id_ordem,
            id_ordem_status: ordem.id_status,
          })),
          expediente_funcionarios: ordensComFuncionarios.flatMap(ordem =>
            ordem.funcionariosSelecionados.map(funcionarioId => ({
              id_funcionario: funcionarioId, // ID do funcionário
              id_ordem: ordem.id_ordem, // ID da ordem associada
              id_ordem_status: ordem.id_status, // Status da ordem
              id_status_inicio: 15, // Valor fixo ou dinamicamente atribuído
              inicio_at: this.dataAbertura, // Valor compartilhado ou específico
              motivo: "abertura", // Motivo padrão ou atribuído
            }))
          ),
        };

        // Verifica se há ordens para enviar
        if (dadosAbertura.expediente_ordem.length === 0) {
          toast.warning("Nenhuma ordem está associada aos funcionários selecionados.");
          this.loadingDialog = false;
          return;
        }

        // Chama o serviço para salvar a abertura
        const response = await aberturaExpedienteService.salvarAbertura(dadosAbertura);

        // Verificar a resposta da API
        this.successDialog = true;
        //toast.success("Abertura salva com sucesso!");
      } catch (error) {
        console.error("Erro ao salvar abertura:", error);
        toast.error("Erro ao salvar a abertura. Tente novamente.");
      } finally {
        this.loadingDialog = false; // Oculta o carregamento
      }
    },




    // Alterna a seleção de um funcionário para uma ordem
    alternarSelecaoFuncionario(ordemId, funcionarioId) {
      const ordem = this.ordensDoSetor.find((o) => o.id === ordemId);
      if (ordem) {
        const index = ordem.funcionariosSelecionados.indexOf(funcionarioId);
        if (index === -1) {
          // Adicionar funcionário à seleção
          ordem.funcionariosSelecionados.push(funcionarioId);
        } else {
          // Remover funcionário da seleção
          ordem.funcionariosSelecionados.splice(index, 1);
        }
      }
    },



    // Alterna a expansão do card
    toggleOrdem(id) {
      const ordem = this.ordensDoSetor.find((ordem) => ordem.id === id);
      ordem.expanded = !ordem.expanded;
    },
    // Marca todos os funcionários disponíveis em uma ordem
    marcarTodosFuncionarios(ordemId) {
      const ordem = this.ordensDoSetor.find((o) => o.id === ordemId);
      if (ordem) {
        ordem.funcionariosSelecionados = ordem.funcionariosDisponiveis.map((f) => f.id);
      }
    },
    desmarcarTodosFuncionarios(ordemId) {
      const ordem = this.ordensDoSetor.find((o) => o.id === ordemId);
      if (ordem) {
        ordem.funcionariosSelecionados = [];
      }
    },

    // Salva as seleções
    salvarOrdensFuncionarios() {
      const dadosParaSalvar = this.ordensDoSetor.map((ordem) => ({
        id_ordem: ordem.id,
        funcionarios: ordem.funcionariosSelecionados,
      }));
      console.log("Dados a serem salvos:", dadosParaSalvar);
      // Aqui você pode enviar os dados para o backend
    },





    confirmFinalizarFuncionarios() {
      this.diaglogSelecaoFuncionario = !this.diaglogSelecaoFuncionario;

    },

    removerFuncionario(idFuncionario) {
      // Remover o funcionário da lista global `funcionariosSelecionados`
      const index = this.funcionariosSelecionados.findIndex(
        (f) => f.funcionario.id === idFuncionario
      );
      if (index !== -1) {
        this.funcionariosSelecionados.splice(index, 1);

        // Remover o funcionário de cada ordem no `ordensDoSetor`
        this.ordensDoSetor.forEach((ordem) => {
          if (ordem.funcionariosDisponiveis) {
            const indexOrdem = ordem.funcionariosDisponiveis.findIndex(
              (f) => f.id === idFuncionario
            );
            if (indexOrdem !== -1) {
              ordem.funcionariosDisponiveis.splice(indexOrdem, 1);

              // Caso o funcionário estivesse selecionado na ordem, removê-lo também
              const selecionadoIndex = ordem.funcionariosSelecionados.indexOf(idFuncionario);
              if (selecionadoIndex !== -1) {
                ordem.funcionariosSelecionados.splice(selecionadoIndex, 1);
              }
            }
          }
        });
      } else {
        console.warn(`Funcionário com ID ${idFuncionario} não encontrado.`);
      }
    },

    voltarMenu() {
      this.$router.push({ name: "AberturaExpedienteMenuMobile" }).catch(() => { });
    },
    opcaoconfirmCancelar() {
      // Abre o diálogo de confirmação
      // this.$router.push({ name: 'MenuDefault' }).catch(() => { });
      this.cancelarDialog = true;
    },

    // Método para buscar o chefe a partir do ID
    async buscarChefe() {
      if (this.loading) return; // Evita buscar enquanto carrega

      let idChefe = this.id_chefe.trim().toUpperCase();

      // Remover os primeiros 3 caracteres se forem letras
      if (/^[A-Z]{3}/.test(idChefe)) {
        idChefe = idChefe.substring(3);
      }

      // Converter o ID para inteiro, ignorando entradas inválidas
      const idChefeInt = parseInt(idChefe, 10);

      if (isNaN(idChefeInt)) {
        toast.error("O ID deve ser um número válido.");
        return;
      }

      const chefe = this.funcionarios.find((f) => f.id === idChefeInt);
      if (chefe) {
        this.chefeSelecionado = chefe;
        // Após selecionar o chefe, carregar os setores
        await this.carregarSetores();

        await this.buscarChefeSetor(idChefeInt);
      } else {
        toast.error("Chefe de setor não encontrado.");
      }
    },

    // Método para carregar setores após selecionar o chefe
    async carregarSetores() {
      try {
        this.mensagemDialog = "Carregando setores...";
        this.loadingDialog = true;
        const response = await maquinaMapaService.fetchSetores();
        if (response && Array.isArray(response)) {
          this.setores = response;
        } else {
          throw new Error("Formato de dados inválido.");
        }
      } catch (error) {
        console.error("Erro ao carregar setores:", error);
        this.errorDialog = true;
        toast.error("Erro ao carregar setores. Tente novamente.");
      } finally {
        this.loadingDialog = false;
      }
    },

    // Método para abrir o sheet de setores
    abrirSheetSetor() {
      if (this.setores.length === 0) {
        this.carregarSetores();
      }
      this.sheetSetor = true;
    },

    // Método para selecionar o setor e carregar sub-setores
    async selectSetor(setor) {
      this.setorSelecionado = setor;
      this.sheetSetor = false;
      this.subSetorSelecionado = null; // Reseta o sub-setor ao mudar o setor
      await this.carregarSubSetores();
    },



    buscarFuncionario() {
      if (this.loading) return; // Evita buscar enquanto carrega

      let idFuncionario = this.currentFuncionarioSelecionadoId.trim().toUpperCase();

      // Verificar se o formato é do tipo "#FUN" e capturar os números
      const match = idFuncionario.match(/^#FUN(\d+)$/);

      if (match) {
        // Extraímos o número após "#FUNC"
        idFuncionario = parseInt(match[1], 10);
      } else {
        // Tenta converter o valor diretamente para número
        idFuncionario = parseInt(idFuncionario, 10);

        // Verifica se o valor convertido é válido
        if (isNaN(idFuncionario)) {
          toast.error("O ID deve ser um número válido ou começar com '#FUNC'.");
          return;
        }
      }

      // Verificar se o funcionário já foi adicionado à lista
      const funcionarioJaExiste = this.funcionariosSelecionados.some(
        (f) => parseInt(f.funcionario.id, 10) === idFuncionario
      );

      if (funcionarioJaExiste) {
        this.currentFuncionarioSelecionadoId = "";
        toast.warning("Este funcionário já foi adicionado.");
        return;
      }

      // nao deixar cadastrar o funcinario se for igual id_chefe
      if (idFuncionario == this.id_chefe) {
        this.currentFuncionarioSelecionadoId = "";
        toast.warning("O chefe não pode ser adicionado como funcionário.");
        return;
      }
      // Buscar o funcionário na lista de funcionários
      const funcionario = this.funcionarios.find(
        (f) => parseInt(f.id, 10) === idFuncionario
      );

      if (funcionario) {
        // Verificar se o funcionário é o chefe
        if (funcionario.isChefe) {
          this.currentFuncionarioSelecionadoId = "";
          toast.warning("O chefe não pode ser adicionado como funcionário.");
          return;
        }

        // Definir o funcionário atual
        this.currentFuncionario = funcionario;
        this.finalizarFuncionario();
      } else {
        this.currentFuncionarioSelecionadoId = "";
        toast.error("Funcionário não encontrado.");
      }
    },


    // Método para finalizar a adição do funcionário atual
    finalizarFuncionario() {
      if (!this.currentFuncionario) {
        toast.warning("Por favor, selecione um funcionário.");
        return;
      }

      // Verificar se o funcionário já foi adicionado
      const funcionarioJaExiste = this.funcionariosSelecionados.some(
        (f) => f.funcionario.id === this.currentFuncionario.id
      );

      if (funcionarioJaExiste) {
        toast.warning("Este funcionário já foi adicionado.");
        return;
      }

      // Verificar se o funcionário é o chefe
      if (this.currentFuncionario.isChefe) {
        toast.warning("O chefe não pode ser adicionado como funcionário.");
        return;
      }

      // Adicionar o funcionário e suas máquinas à lista global
      this.funcionariosSelecionados.push({
        funcionario: this.currentFuncionario,
        maquinas: [...this.currentMaquinasSelecionadas],
      });

      // Adicionar o funcionário a cada ordem no `ordensDoSetor`
      this.ordensDoSetor.forEach((ordem) => {
        // Evitar duplicatas
        const funcionarioJaNaOrdem = ordem.funcionariosDisponiveis?.some(
          (f) => f.id === this.currentFuncionario.id
        );

        if (!funcionarioJaNaOrdem) {
          // Criar a lista `funcionariosDisponiveis` caso ainda não exista
          if (!ordem.funcionariosDisponiveis) {
            ordem.funcionariosDisponiveis = [];
          }
          ordem.funcionariosDisponiveis.push({
            id: this.currentFuncionario.id,
            nome: this.currentFuncionario.nome,
            cargo_nome: this.currentFuncionario.cargo_nome || "Cargo não informado",
          });
        }
      });

      // Limpar os dados atuais
      this.currentFuncionario = null;
      this.currentFuncionarioSelecionadoId = "";
      this.currentMaquinasSelecionadas = [];
      this.maquinaSelecionadaId = "";

      // Perguntar se deseja adicionar mais funcionários
      this.dialogAdicionarFuncionario = false;
      this.adicionarMaisFuncionarios;
    },

    // Método para adicionar mais funcionários
    adicionarMaisFuncionarios() {
      this.adicionarMaisFuncionariosDialog = false;
      this.$nextTick(() => {
        this.$refs.funcionarioInput.focus();
      });
    },

    // Método para confirmar o cancelamento
    confirmCancelar() {
      this.cancelarDialog = true;
    },

    // Ação de cancelamento
    cancelarAcao() {
      this.cancelarDialog = false;
      this.$router.push({ name: "AberturaExpedienteMenuMobile" }).catch(() => { });
    },

    // Método para confirmar a finalização do expediente
    confirmFinalizarExpediente() {
      this.confirmFinalizarExpedienteDialog = true;
    },

    async buscarChefeSetor(id) {
      try {
        this.mensagemDialog = "Buscando o setor do chefe.";
        this.loading = true;
        this.loadingDialog = true;

        // Chama a API para obter os dados
        const response = await aberturaExpedienteService.obterChefeSetor(id);

        // Verifica se a resposta possui o formato esperado
        if (response) {
          // Pega o primeiro setor retornado
          const setor = response;

          // Preenche os dados do setor
          this.id_chefe_setor = setor.id;
          this.setorSelecionado = this.setores.find(
            (setor) => setor.id === this.id_chefe_setor
          );

          // Preenche as ordens do setor
          if (setor.setores_ordens && setor.setores_ordens.length > 0) {
            this.ordensDoSetor = setor.setores_ordens.map((ordem) => ({
              id: ordem.id,
              id_ordem: ordem.id_ordem,
              id_status: ordem.id_ordem_status,
              // INFERNO
              numero_ordem: ordem.ordem_producao?.id_ordem || "Não informado",
              numero_pedido: ordem.ordem_producao?.id_pedido || "Não informado",
              etapata: ordem.ordem_producao_status?.producao_status_tipo?.producao_status || "Não informado",
              etapataComplemento: ordem.ordem_producao_status?.complemento || "Não informado",
              cliente: ordem.ordem_producao?.cliente?.nome || "Desconhecido",
              modelo: ordem.ordem_producao?.modelo?.descricao || "Modelo não informado",
              quantidade: ordem.ordem_producao?.quantidade || 0,
              previsao_entrega: ordem.ordem_producao?.previsao_entrega || "Não informado",
              funcionariosDisponiveis: [], // Inicializado como array vazio
              funcionariosSelecionados: [], // Inicializado como array vazio
            }));
          } else {
            this.ordensDoSetor = [];
            toast.warning("Nenhuma ordem encontrada para este setor.");
          }
        } else {
          // Caso o formato da resposta não seja válido ou vazio
          throw new Error("Nenhum setor encontrado para o chefe especificado.");
        }
      } catch (error) {
        // Captura e exibe erros no console e para o usuário
        console.error("Erro ao carregar dados:", error);
        this.errorDialog = true;
        toast.error(error.message || "Erro ao carregar dados.");
      } finally {
        // Sempre desativa os indicadores de carregamento
        this.loading = false;
        this.loadingDialog = false;
      }
    }
    ,




    async carregarFuncionarios() {
      try {
        this.mensagemDialog = "Carregando Funcionários...";
        this.loading = true;
        this.loadingDialog = true;

        // Chama a API para obter os dados
        const response = await funcionarioService.fetchFuncionariosSimples();


        // Verifica se a resposta possui o formato esperado
        if (
          response &&
          response.success === true &&
          Array.isArray(response.data)
        ) {
          this.funcionarios = response.data; // Atribui os dados recebidos
          toast.success("Funcionários carregados com sucesso!");
        } else {
          // Caso o formato seja inesperado, gera um erro detalhado
          console.error("Formato inesperado da resposta da API:", response);
          throw new Error(
            "Formato de resposta inválido ou nenhum funcionário encontrado."
          );
        }
      } catch (error) {
        // Captura e exibe erros no console e para o usuário
        console.error("Erro ao carregar funcionários:", error);
        this.errorDialog = true;
        toast.error(error.message || "Erro ao carregar funcionários.");
      } finally {
        // Sempre desativa os indicadores de carregamento
        this.loading = false;
        this.loadingDialog = false;
      }
    },

    // Método para obter a URL da foto do chefe e funcionários
    getChefeFotoUrl(fotoNome) {
      // Ajuste o caminho conforme necessário
      return `https://tabosasistemas.com.br/jodarc/_lib/file/img/funcionarios/${fotoNome}`;
    },

    // Filtra os setores com base na pesquisa
    getSetoresFiltrados() {
      return this.setores.filter((setor) =>
        setor.descricao_setor
          .toLowerCase()
          .includes(this.searchSetor.toLowerCase())
      );
    },



    // Verifica se o dispositivo é móvel
    isMobile() {
      return window.innerWidth <= 600;
    },

    // Recarrega a página após sucesso
    recarregarPagina() {
      location.reload();
    },

    // Método para cancelar a seleção do funcionário
    cancelarFuncionario() {
      this.dialogAdicionarFuncionario = false;

      this.currentFuncionario = null;
      this.currentFuncionarioSelecionadoId = "";
      this.currentMaquinasSelecionadas = [];
      this.maquinaSelecionadaId = "";
    },
  },
  mounted() {
    this.mensagemDialog = "Carregando dados...";
    this.loadingDialog = true;
    this.$nextTick(async () => {
      this.mensagemDialog = "Carregando dados.";

      await this.carregarFuncionarios();
      // await this.carregarMaquinas();

    });
    this.loadingDialog = false;
  },
  created() {
    this.id_chefe = String(this.ObjUsuario.id_funcionario).trim();
  },
};
</script>
<style scoped>
.v-btn {
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

ul li {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

ul li v-btn {
  margin-left: 10px;
}

.dialog-content {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: auto;
  transition: padding-bottom 0.3s ease;
}

.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}

.mb-1 {
  margin-bottom: 4px;
}

.sub-setor-text span {
  font-size: 0.875rem;
  color: #666;
}

/* Estilos para o Card do Chefe */
.chefe-card {
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.funcionario-card {
  padding: 16px;
  background-color: #e8f5e9;
  border-radius: 8px;
}

.chefe-foto,
.funcionario-foto {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 50%;
}

.funcionario-foto {
  width: 80px;
  height: 80px;
}

.chefe-nome {
  font-size: 1.5rem;
  font-weight: bold;
}

.funcionario-nome {
  font-size: 1.2rem;
  font-weight: bold;
}

.chefe-info-col,
.funcionario-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.maquina-chip {
  margin-right: 4px;
  margin-top: 4px;
}

@media (min-width: 600px) {

  .chefe-foto-col,
  .funcionario-foto-col {
    max-width: 200px;
  }

  .chefe-foto {
    height: 200px;
  }

  .funcionario-foto {
    width: 60px;
    height: 60px;
  }

  .chefe-nome {
    font-size: 2rem;
  }

  .funcionario-nome {
    font-size: 1.5rem;
  }
}

.title-sheet {
  background: linear-gradient(to right, #e0e0e0, #f5f5f5);
  /* Degradê cinza */
  width: 100%;
  /* Largura total */
  padding: 8px;
  /* Espaçamento interno */
}

.title-text {
  margin: 0;
  /* Remove a margem padrão do h3 */
  text-align: center;
  /* Centraliza o texto */
  color: #424242;
  /* Cor do texto para melhor contraste */
}

.maquinas-lista-container {
  max-height: 500px;
  /* Ajuste a altura máxima conforme necessário */
  min-width: 100%;
  overflow-y: auto;
}

.maquinas-lista-container::-webkit-scrollbar {
  width: 8px;
}

.maquinas-lista-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 0;
}

.maquinas-lista-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.employee-photo {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  /* Tornar os cantos levemente arredondados */
  border: 1px solid #ddd;
  /* Opcional: borda para destaque */
}

.ordem-selecionada {
  background: linear-gradient(90deg, #28a745, #218838);
  color: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.ordem-selecionada:hover {
  background: linear-gradient(90deg, #34ce57, #28a745);
}

.ordem-nao-selecionada {
  background: linear-gradient(90deg, #d6d8d9, #adb5bd);
  color: black;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.ordem-nao-selecionada:hover {
  background: linear-gradient(90deg, #e0e0e0, #bfc6ce);
}
</style>
